import { render, staticRenderFns } from "./EpcScore.vue?vue&type=template&id=edbe148a&scoped=true&"
import script from "./EpcScore.vue?vue&type=script&lang=js&"
export * from "./EpcScore.vue?vue&type=script&lang=js&"
import style0 from "./EpcScore.vue?vue&type=style&index=0&id=edbe148a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbe148a",
  null
  
)

export default component.exports